<template>
  <div class="header">
    <!-- Unauthenticated User Menu -->
    <md-toolbar class="md-small menu-bar" v-if="!user">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <!-- Mobile Menu -->
          <md-menu md-size="big" md-align-trigger :mdCloseOnClick="true" :mdCloseOnSelect="true">
            <md-button class="md-icon-button" md-menu-trigger>
              <md-icon class="menuIcon">menu</md-icon>
            </md-button>
            <md-menu-content :style="{ background: 'white', maxHeight: 'unset' }" class="dropdown">
              <md-menu-item v-for="link in getAnonymousUserLinks" :key="link.label">
                <p class="item" @click="onClickLink(link)">{{ link.label }}</p>
              </md-menu-item>
              <div>
                <div class="contact-us">
                  <p style="font-size: 0.8rem">
                    <translate>CONTACT US</translate><br />
                    {{ organizationDetails.supportEmail }}
                  </p>
                </div>
              </div>
            </md-menu-content>
          </md-menu>
          <!-- End Mobile Menu -->
        </div>

        <div class="md-toolbar-section-end" v-if="enableLangPref">
          <md-menu>
            <md-button class="desktop-menu-btn">
              <div class="desktop-menu-toggle">
                <img :src="require('../assets/images/lang-toggle.png')" alt="languages" />
                <p>
                  <span
                    class="item inherit-font"
                    :class="{ underline: $language.current === 'en_US' }"
                    @click="onToggleLanguage('en_US')"
                    >EN</span
                  >
                  <span class="item inherit-font">&nbsp;/&nbsp;</span
                  ><span
                    class="item inherit-font"
                    :class="{ underline: $language.current === 'es_ES' }"
                    @click="onToggleLanguage('es_ES')"
                    >ES</span
                  >
                </p>
              </div>
            </md-button>
          </md-menu>
        </div>
      </div>
    </md-toolbar>
    <!-- Unauthenticated User Menu -->

    <!-- Employee User Menu -->
    <md-toolbar class="md-small menu-bar" v-if="user && user.isEmployee">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <!-- Mobile Menu -->
          <md-menu md-size="big" md-align-trigger :mdCloseOnClick="true" :mdCloseOnSelect="true">
            <md-button class="md-icon-button" md-menu-trigger>
              <md-icon class="menuIcon">menu</md-icon>
            </md-button>

            <md-menu-content
              :style="{ background: 'white', maxHeight: 'unset', 'z-index': 1084 }"
              class="dropdown"
            >
              <md-menu-item v-for="link in getEmployeeLinks" :key="link.label">
                <p class="item" @click="onClickLink(link)">{{ link.label }}</p>
              </md-menu-item>
              <div>
                <div class="contact-us">
                  <p style="font-size: 0.8rem">
                    <translate>CONTACT US</translate><br />
                    {{ organizationDetails.supportEmail }}
                  </p>
                </div>
              </div>
            </md-menu-content>
          </md-menu>
          <!-- End Mobile Menu -->
        </div>

        <div class="md-toolbar-section-end">
          <!-- TODO William 2020-03-24 - Add profile image dropdown menu -->
          <md-menu>
            <md-button class="desktop-menu-btn">
              <p class="item" @click="handleLogout" v-translate>LOG OUT</p>
            </md-button>
          </md-menu>
        </div>
      </div>
    </md-toolbar>
    <!-- Employee User Menu -->

    <!-- Staff Users Menu -->
    <md-toolbar class="md-small menu-bar" v-if="user && user.isStaff">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <!-- Mobile Menu -->
          <md-menu md-size="big" md-align-trigger :mdCloseOnClick="true" :mdCloseOnSelect="true">
            <md-button class="mobile-menu-btn md-icon-button" md-menu-trigger>
              <md-icon class="menuIcon">menu</md-icon>
            </md-button>
            <md-menu-content :style="{ background: 'white', maxHeight: 'unset' }" class="dropdown">
              <md-menu-item v-for="link in getStaffLinks" :key="link.label">
                <p class="item" @click="onClickLink(link)">{{ link.label }}</p>
              </md-menu-item>
            </md-menu-content>
          </md-menu>
          <!-- End Mobile Menu -->

          <!-- Desktop Menu -->
          <div class="md-small-hide">
            <md-menu>
              <md-button v-for="link in getStaffLinks" :key="link.label" class="desktop-menu-btn">
                <p class="item" @click="onClickLink(link)">{{ link.label }}</p>
              </md-button>
            </md-menu>
          </div>
          <!-- End Desktop Menu -->
        </div>

        <div class="md-toolbar-section-end">
          <!-- TODO William 2020-03-24 - Add profile image dropdown menu -->
          <md-menu>
            <md-button class="desktop-menu-btn">
              <p class="item" @click="handleLogout" v-translate>LOG OUT</p>
            </md-button>
          </md-menu>
        </div>
      </div>
    </md-toolbar>
    <!-- End Staff Users Menu -->

    <!-- Admin Users Menu -->
    <md-toolbar class="md-small menu-bar" v-if="user && user.isAdmin">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <!-- Mobile Menu -->
          <md-menu md-size="big" md-align-trigger :mdCloseOnClick="true" :mdCloseOnSelect="true">
            <md-button class="mobile-menu-btn md-icon-button" md-menu-trigger>
              <md-icon class="menuIcon">menu</md-icon>
            </md-button>
            <md-menu-content :style="{ background: 'white', maxHeight: 'unset' }" class="dropdown">
              <md-menu-item v-for="link in getAdminLinks" :key="link.label">
                <p class="item" @click="onClickLink(link)">{{ link.label }}</p>
              </md-menu-item>
            </md-menu-content>
          </md-menu>
          <!-- End Mobile Menu -->

          <!-- Desktop Menu -->
          <div class="md-small-hide">
            <md-menu>
              <md-button v-for="link in getAdminLinks" :key="link.label" class="desktop-menu-btn">
                <p class="item" @click="onClickLink(link)">{{ link.label }}</p>
              </md-button>
            </md-menu>
          </div>
          <!-- End Desktop Menu -->
        </div>

        <div class="md-toolbar-section-end">
          <!-- TODO William 2020-03-24 - Add profile image dropdown menu -->
          <md-menu>
            <md-button class="desktop-menu-btn">
              <p class="item" @click="handleLogout" v-translate>LOG OUT</p>
            </md-button>
          </md-menu>
        </div>
      </div>
    </md-toolbar>
    <!-- End Admin Users Menu -->
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import AdminPermissions from '@/services/adminPermissions'
import Auth from '@/services/auth'
import { trackEvent } from '@/services/googleAnalytics'

const ADMIN_LINKS = [
  {
    label: 'REPORTS',
    route: { name: 'StaffReports' },
    permissionRequired: {
      permission: 'canViewReports',
      allowedValues: [true],
    },
  },
  {
    label: '', // set when retrieved, need use of 'this' in order to set value
    route: { name: 'StaffEmployeesOverview' },
    permissionRequired: {
      permission: 'canViewEmployees',
      allowedValues: [true],
    },
  },
  {
    label: 'REQUESTS',
    route: { name: 'StaffRequestsOverview' },
    permissionRequired: {
      permission: 'viewWhichRequests',
      allowedValues: [
        AdminPermissions.options.ALL_REQUESTS,
        AdminPermissions.options.REFERRED_REQUESTS_ONLY,
      ],
    },
  },
  {
    label: 'UPLOAD LIST',
    route: { name: 'StaffEligibilityUploader' },
    permissionRequired: {
      permission: 'canViewEmployeeCodes',
      allowedValues: [true],
    },
  },
  {
    label: 'SFTP FEED',
    route: { name: 'StaffEligibilityFileFeed' },
    permissionRequired: {
      permission: 'canViewEmployeeCodes',
      allowedValues: [true],
    },
  },
]
const STAFF_LINKS = [
  { label: 'REPORTS', route: { name: 'StaffReports' } },
  { label: 'USERS', route: { name: 'StaffEmployeesOverview' } },
  { label: 'REQUESTS', route: { name: 'StaffRequestsOverview' } },
  { label: 'DISBURSEMENTS', route: { name: 'StaffPayoutsOverview' } },
  { label: 'UPLOAD LIST', route: { name: 'StaffEligibilityUploader' } },
  { label: 'SFTP FEED', route: { name: 'StaffEligibilityFileFeed' } },
]

export default {
  name: 'Header',
  data() {
    return {
      isCollapsed: false,
      ADMIN_LINKS,
      STAFF_LINKS,
      enableLangPref: this.$store.state.organizationDetails.enableLanguagePref,
    }
  },
  methods: {
    onToggleLanguage(value) {
      this.$store.dispatch('updateCurrentLanguage', value)
    },
    /* User has clicked a menu link. */
    onClickLink(link) {
      if (link.googleAnalytics) {
        trackEvent(link.googleAnalytics.action, '', 'Menu', '')
      }
      // If router throws an error because of a route guard redirection, just log it
      this.$router.push({ name: link.route.name }).catch((error) => console.log(error.message))
    },
    handleLogout() {
      Auth.logout()
      if (this.$route.name != 'Home') {
        this.$router.push({ name: 'Home' })
        this.toggleDropDownMenu()
      }
    },
    toggleDropDownMenu() {
      this.isCollapsed = !this.isCollapsed
    },
    /* Return True if adminPermissions contains allowed value for required permission. */
    adminHasPermission(link) {
      // If link doesn't have any specific admin permission requirements, return true
      if (!link.permissionRequired) {
        return true
      }
      return link.permissionRequired.allowedValues.includes(
        this.user.adminPermissions[link.permissionRequired.permission],
      )
    },
    /* Return True if organization has the correct feature enabled to see a menu link. */
    organizationHasFeature(link) {
      // If link doesn't have any specific feature requirements, return true
      if (!link.featureRequired) {
        return true
      }
      return link.featureRequired.allowedValues.includes(
        this.organizationDetails[link.featureRequired.field],
      )
    },
  },
  computed: {
    ...mapState(['user', 'organizationDetails']),
    ...mapGetters(['userIsLoggedIn']),
    /* Return all menu links appropriate for an anonymous user. */
    getAnonymousUserLinks() {
      return this.ANONYMOUS_USER_LINKS.filter((link) => {
        return this.organizationHasFeature(link) ? true : false
      })
    },
    /* Return all menu links appropriate for an employee. */
    getEmployeeLinks() {
      return this.EMPLOYEE_LINKS.filter((link) => {
        return this.organizationHasFeature(link) ? true : false
      })
    },
    /* Return all menu links appropriate for an admin. */
    getAdminLinks() {
      this.ADMIN_LINKS[1]['label'] =
        this.organizationDetails.customVariables && this.organizationDetails.customVariables.cv3
          ? this.organizationDetails.customVariables.cv3 + 's'
          : 'USERS'
      return this.ADMIN_LINKS.filter((link) => {
        return this.adminHasPermission(link) ? true : false
      })
    },
    /* Return all menu links appropriate for a staff. */
    getStaffLinks() {
      return this.STAFF_LINKS
    },
    ANONYMOUS_USER_LINKS() {
      return [
        { label: this.$gettext('HOME'), route: { name: 'Home' } },
        { label: this.$gettext('header FAQ'), route: { name: 'FAQ' } },
        {
          label: this.$gettext('GIVE'),
          route: { name: 'AddPayment' },
          featureRequired: { field: 'donationsEnabled', allowedValues: [true] },
        },
        {
          label: this.$gettext('FIND RESOURCES'),
          route: { name: 'FindResources' },
          featureRequired: { field: 'springFourEnabled', allowedValues: [true] },
          googleAnalytics: { action: 'clicked-resources-cta' },
        },
        { label: this.$gettext('SIGN IN'), route: { name: 'Login' } },
      ]
    },
    EMPLOYEE_LINKS() {
      return [
        { label: this.$gettext('HOME'), route: { name: 'Home' } },
        { label: this.$gettext('REQUEST'), route: { name: 'Request' } },
        {
          label: this.$gettext('GIVE'),
          route: { name: 'AddPayment' },
          featureRequired: { field: 'donationsEnabled', allowedValues: [true] },
        },
        {
          label: this.$gettext('FIND RESOURCES'),
          route: { name: 'FindResources' },
          featureRequired: { field: 'springFourEnabled', allowedValues: [true] },
          googleAnalytics: { action: 'clicked-resources-cta' },
        },
        { label: this.$gettext('MY ACTIVITY'), route: { name: 'MyActivity' } },
        { label: this.$gettext('PROFILE'), route: { name: 'MyProfile' } },
        { label: this.$gettext('header FAQ'), route: { name: 'FAQ' } },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/mixins/spinners';
@import '../styles/variables';

.mobile-menu-btn {
  @media (min-width: $mobile-break-point) {
    display: none;
  }
}

.desktop-menu-btn {
  .item {
    color: white;
    font-weight: bold;
  }
}

.desktop-menu-toggle {
  display: flex;
  align-items: center;

  img {
    height: 1.25em;
    padding-right: 0.5em;
  }
}

.menu-bar {
  background: black;
}
.md-toolbar,
.md-toolbar-row {
  // NIP 10/19/20 HACK: VueMaterial toolbars change height based on screenwidth inside a media query.
  //                    We need to overwrite this and keep our height consistent, so we can subtract
  //                    against this height to generate $compensated-screen-height
  @media (min-width: 0px) {
    min-height: $app-header-height;
    max-height: $app-header-height;
  }
}

.menu {
  box-shadow: 0 0.25rem 0.5rem 0 $mid-gray;
  border-bottom-left-radius: 0.6rem;
  border-bottom-right-radius: 0.6rem;
  border: 1px, solid $mid-gray;
  background-color: white;
  z-index: 2;
  width: 15.625rem;
  position: absolute;
}
.menuIcon {
  font-size: 1.5625rem;
  margin: 1rem;
  color: white;
  outline: none;
}
.item {
  font-family: 'Poppins-Medium';
  color: $black;
  cursor: pointer;
}
.item:hover {
  text-decoration: underline;
}
li {
  color: $black;
  padding: 0.625rem 0.9375rem;
}
span {
  font-family: 'Poppins-Light';
}

.contact-us {
  margin-top: 1rem;
  padding: 0.625rem 0.9375rem;
  display: flex;
  flex-direction: column;
}
ul {
  list-style: none;
}

.underline {
  text-decoration: underline;
}
</style>
